import {combineReducers} from 'redux'
import firebaseReducer from './firebaseReducer'
import userReducer from './userReducer'
import {initialState} from './initialState'

const appReducer = combineReducers({
  firebaseReducer: firebaseReducer,
  userReducer: userReducer,
})

const rootReducer = (state, action) => {
  if (action.type === 'CLEAR_STORE') {
    state = {
      ...state,
      userReducer: {...structuredClone(initialState), isLoading: false},
      // firebaseReducer: state.firebaseReducer,
    }
  }
  return appReducer(state, action)
}

export default rootReducer
